import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { openEmailReturnLabelModal } from '../../../store/returns/returns.actions';
import Global from '../../../store/global-selectors';

const ResendLabels = () => {
  const dispatch = useDispatch();

  const resendLabels = useCallback(() => {
    dispatch(openEmailReturnLabelModal());
  }, [dispatch]);

  const selectedReturnsCount = useSelector(Global.selectSelectedReturnsCount);
  return (
    <Button disabled={selectedReturnsCount < 1} onClick={resendLabels} theme='tertiary'>
      <FormattedMessage defaultMessage='Resend Return Label(s)' description='returnsPageHeader.resendLabels' id='vzCpgK' />
    </Button>
  );
};

export default ResendLabels;
